import Vue from 'vue'

export const Success = (message, title='Success!') => {
	return Vue.swal({
		icon: 'success',
		title: title,
		allowOutsideClick: false,
		text: message
	})
}


export const Error = (response, message = 'An error occured', title = 'Oops!')  => {

	const opt={
		icon: 'error',
		title: title,
		allowOutsideClick: false
	}
	try {
		switch(response.status) {
			case 404:
				opt.title='404 not Found!'
				if(response.data.hasOwnProperty('message')) {
					opt.text=response.data.message
				} else {
					opt.text='Sorry the existance of said query was not found'
				}
				break

			case 422:
				let msg=''
				const errors=response.data.errors
				Object.keys(errors).forEach(keyError => {
					msg+=errors[keyError].map(error => '<li>'+error+'</li>')
				})
				opt.title='Validation Error!'
				opt.html='<ul class="text-left">'+msg+'</ul>'
				break

			case 400:
				opt.text=response.data.message
				break

			default:
				opt.text = message
				break;
				
		}
	} catch (e) {
		console.error(e)
		opt.text=message
	}
	

	return Vue.swal(opt)
}